import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
// Public canonical origin — strips all trailing slashes and ensures subpath prefix
const rawSiteUrl = (process.env.REACT_APP_SITE_URL || BACKEND_URL || "").replace(/\/+$/, "");
const publicPath = (process.env.PUBLIC_URL || "/knowledge").replace(/\/+$/, "");
export const SITE_URL = rawSiteUrl
  ? (rawSiteUrl.endsWith(publicPath) || !publicPath ? rawSiteUrl : `${rawSiteUrl}${publicPath}`)
  : publicPath;

/**
 * Cleanly joins a base URL with path segments without duplicate slashes.
 */
export function joinUrl(base, ...parts) {
  const cleanBase = (base || "").replace(/\/+$/, "");
  const cleanPath = parts
    .filter(Boolean)
    .map((p) => String(p).replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/");
  return cleanPath ? `${cleanBase}/${cleanPath}` : cleanBase;
}

const http = axios.create({ baseURL: API });

export async function getStats() {
  const { data } = await http.get(`/stats`);
  return data;
}

export async function getEntity(type, slug) {
  const { data } = await http.get(`/entity/${type}/${slug}`);
  return data;
}

export async function listEntities(type, params = {}) {
  const { data } = await http.get(`/list/${type}`, { params });
  return data;
}

export async function searchEntities(q, limit = 20) {
  const { data } = await http.get(`/search`, { params: { q, limit } });
  return data;
}

// Build a router URL from an entity reference {type, slug}
export function refUrl(ref) {
  if (!ref) return "/";
  switch (ref.type) {
    case "home":
      return "/";
    case "categories":
      return "/categories";
    case "companies":
      return "/companies";
    case "services":
      return "/services";
    default:
      return `/${ref.type}/${ref.slug}`;
  }
}
